import type { FC } from "react";
import { useEffect, useMemo } from "react";

import { getPaths } from "core/getPaths";
import PaymentMetrics from "shared/Components/PaymentMetrics";

import { useLeague } from "shared/hooks";

import { EntitySoccerLeagueRoles } from "shared/types";
import { isRoleAvailable } from "utils/isRoleAvailable";

import PaymentRequestsTable from "../../Components/PaymentRequestsTable";
import LeagueTransactionsHistory from "../../Components/TransactionsHistory";

const { league: leagueRoutes } = getPaths();

const LeagueFinance: FC<{ leagueId: string }> = ({ leagueId }) => {
	const { checkPaymentAccount, getRegistrationPaymentAccountLink, getData: getLeagueData } = useLeague();
	const { loadingPaymentAccount, registeringPaymentAccount, paymentAccount, userLeagueRoles, isPaymentAccountValid } =
		getLeagueData();

	const isOwner = useMemo(() => isRoleAvailable(userLeagueRoles, [EntitySoccerLeagueRoles.OWNER]), [userLeagueRoles]);

	useEffect(() => {
		isOwner && checkPaymentAccount(leagueId);
	}, [checkPaymentAccount, isOwner, leagueId]);

	const registerPaymentAccount = (countryCode: string) => {
		getRegistrationPaymentAccountLink({
			id: leagueId,
			redirectLink: `${window.location.origin}${leagueRoutes.getPath()}/${leagueId}/finance`,
			countryCode
		});
	};

	return (
		<div className="flex flex-col gap-4">
			<PaymentMetrics
				objectId={leagueId}
				allowViewStripeDashboard={isOwner}
				paymentAccountExists={isOwner ? !!paymentAccount?.detailsSubmitted : false}
				onRegisterPaymentAccount={isOwner ? registerPaymentAccount : undefined}
				requestingRegistration={loadingPaymentAccount || registeringPaymentAccount}
				stripeAccountValid={isPaymentAccountValid}
			/>
			{/*<CardInfoRow />*/}
			<PaymentRequestsTable leagueId={leagueId} allowCreatePayments={isOwner && !!paymentAccount?.detailsSubmitted} />
			{/* <ExpensesTable leagueId={leagueId} canPay={isOwner} /> */}
			<LeagueTransactionsHistory leagueId={leagueId} />
		</div>
	);
};

export default LeagueFinance;
